export enum NotificationLife {
  Short = 2000,
  Common = 3000,
  Long = 4000
}
